import { Component } from 'react';

export default class Api extends Component {
  static baseUrl = Api.getBaseUrl();
  // static IMAGE_URL = 'http://liveapi.zapcase.com/media';
  // static IMAGE_URL = 'http://devapi.zapcase.com/media';
  static IMAGE_URL = 'https://devapi.zapcase.com/media';
  /* old razorpay details */
  // static razorpay_key_id = 'rzp_test_rVzeZAgo8DWioU'; // testing
  // static razorpay_key_id = 'rzp_live_TtfpRJyDHzgnkS'; // old live
  // static razorpay_key_id = 'rzp_live_8rxtmsCgSMJoBv'; // live

  /* new razorpay details */
  // static razorpay_key_id = 'rzp_test_FgsTn0123DAODS'; // testing
  static razorpay_key_id = 'rzp_live_I1d8u5i9TEwcjY'; // live

  static loginUrl = `${Api.baseUrl}login/`;
  static logoutUrl = `${Api.baseUrl}logout`;
  static uploadUrl = `${Api.baseUrl}files/`;
  static uploadCsvUrl = `${Api.baseUrl}csv-upload/`;
  static exportOrder = `${Api.baseUrl}order-export/`;

  static catalogUrl = `${Api.baseUrl}catalogs/`;

  static categoryUrl = `${Api.baseUrl}categories/`;

  static makeUrl = `${Api.baseUrl}makes/`;

  static modelurl = `${Api.baseUrl}models/`;

  static caseTypeUrl = `${Api.baseUrl}case-types/`;

  static userUrl = `${Api.baseUrl}users/`;

  static rolesUrl = `${Api.baseUrl}roles/`;

  static dealerUrl = `${Api.baseUrl}dealers/`;

  static profileUrl = `${Api.baseUrl}profile/`;

  static logoutUrl = `${Api.baseUrl}logout/`;

  static forgetPassUrl = `${Api.baseUrl}forget-password/`;
  static vrifyOtpUrl = `${Api.baseUrl}verify-otp/`;
  static resetPassUrl = `${Api.baseUrl}reset-password/`;
  static changePassUrl = `${Api.baseUrl}change-password/`;

  static orderReturn = `${Api.baseUrl}orders-return/`;

  static orderUrl = `${Api.baseUrl}orders/`;
  static orderCountUrl = `${Api.baseUrl}order/count/`;

  static stateUrl = `${Api.baseUrl}state/`;
  static cityUrl = `${Api.baseUrl}city/`;

  static bgImageUrl = `${Api.baseUrl}backgrounds/`;

  static fontUrl = `${Api.baseUrl}fonts/`;

  static shippingUrl = `${Api.baseUrl}shipping/`;
  static orderStatusHistory = `${Api.baseUrl}orders-status-history/`;

  static offerUrl = `${Api.baseUrl}offers/`;

  static walletUrl = `${Api.baseUrl}wallets/`;
  static notificationsUrl = `${Api.baseUrl}notifications/`;
  static paytmWalletUrl = `${Api.baseUrl}paytm-wallets/`;

  static assetUrl = `${Api.baseUrl}assets/`;
  static dealerAssetUrl = `${Api.baseUrl}dealer-assets/`;

  static cartUrl = `${Api.baseUrl}cart/`;

  static reportUrl = `${Api.baseUrl}reports/`;

  static walletPaymentUrl = `${Api.baseUrl}payment-wallets/`;

  static notificationUrl = `${Api.baseUrl}notifications/`;

  static orderReceiptUrl = `${Api.baseUrl}order-receipt/`;

  static feedbackUrl = `${Api.baseUrl}feedback/`;

  static productTypeUrl = `${Api.baseUrl}product-types/`;

  static productsUrl = `${Api.baseUrl}products/`;

  static productUrl = `${Api.baseUrl}products/`;

  static bulkUploadUrl = `${Api.baseUrl}bulk-upload/`;

  static repayUrl = `${Api.baseUrl}order-repay/`;

  static settingsUrl = `${Api.baseUrl}general-settings/`;

  static exportMakeModel = `${Api.baseUrl}make-model-export/`;

  static shipmentTracking = `${Api.baseUrl}tracking/`;

  static shipment = `${Api.baseUrl}shipment/`;

  static salesOrderExport = `${Api.baseUrl}sales-order-report/`;

  static walletReport = `${Api.baseUrl}finance-wallets/`;

  static walletReportExport = `${Api.baseUrl}wallet-finance-report/`;

  static usersCsvExport = `${Api.baseUrl}users-report/`;

  static dealerReportUrl = `${Api.baseUrl}dealer-reports/`;

  static externalOrderStatus = `${Api.baseUrl}external-order-requests/`;

  static wooCommerceOrders = `${Api.baseUrl}woocommerce-orders/`;

  static wooCommerceCsvReport = `${Api.baseUrl}woocommerce-order-export/`;

  static wooCommerceorderStatusHistory = `${Api.baseUrl}woocommerce-orders-status-history/`;

  static wooCommerceorderReceiptUrl = `${Api.baseUrl}woocommerce-order-receipt/`;

  static woocommerceOrderCountUrl = `${Api.baseUrl}woocommerce-count/`;
  
  static broadcastNotifications = `${Api.baseUrl}broadcast-notifications/`;

  static codOrderUrl = `${Api.baseUrl}cod-orders/`;
  
  static collectionReportUrl = `${Api.baseUrl}sales-payments/`;

  constructor(props) {
    super(props);
    this.state = {};
    this.environment = 'production';
    this.getBaseUrl = this.getBaseUrl.bind(this);
  }

  
  // Get base URL of APIs
  static getBaseUrl() {
    let url = '';
    const env = 'production1';
    switch (env) {
      case 'production':
        url = 'http://liveapi.zapcase.com/api/v1/';
        break;
      // Default: development server
      default:
        // url = 'http://devapi.zapcase.com/api/v1/';
        url = 'https://devapi.zapcase.com/api/v1/' 
        break;
    }
    return url;
  }

  environment;
}



// WEBPACK FOOTER //
// ./src/util/Api.js